<template>
    <div>
        <div class="space-between common-shadow" style="background: white;position: relative;z-index: 100">
            <div @click="tabIndex=11" :class="'flex-1 tab-item '+(tabIndex==11?'active':'')">未使用</div>
            <div @click="tabIndex=21" :class="'flex-1 tab-item '+(tabIndex==21?'active':'')">已使用</div>
            <div @click="tabIndex=12" :class="'flex-1 tab-item '+(tabIndex==12?'active':'')">已过期</div>
        </div>
        <mt-loadmore :auto-fill="false" :bottomDropText="options.bottomDropText"
                     :bottomPullText="options.bottomPullText"
                     :top-method="loadTop" :bottom-method="loadBottom"
                     :bottom-all-loaded="!options.hasMore"
                     ref="loadmore">
            <div v-if="list.length > 0" class="list-view">
                <div class="space-between ticket-card" v-for="item in list">
                    <div class="ticket-bg text-center vertical-center">
                        <div style="width: 1px;height: 100%"></div>
                        <div>
                            <div class="vertical-center text-center" style="color: white">
                                <span v-if="item.type===1" style="font-size: 28px;vertical-align: bottom;">{{item.fillSubMoney}}</span>
                                <span v-else-if="item.type===2" style="font-size: 28px;vertical-align: bottom;">{{item.cashMoney}}</span>
                                <span style="vertical-align: bottom;padding-bottom: 6px;margin-left: 2px">元</span>
                            </div>
                            <div v-if="item.type===1"
                                 style="color: white;margin-top: 6px;font-size: 12px;padding-bottom: 10px">
                                满{{item.fillMoney}}可使用
                            </div>
                            <div style="color: white;margin-top: 6px;font-size: 12px;padding-bottom: 10px"
                                 v-else-if="item.type===2">抵扣券
                            </div>
                        </div>
                    </div>
                    <div class="flex-1" style="margin-left: 16px">
                        <div style="font-size: 18px;font-weight: bold">{{item.name}}</div>
                        <div style="margin-top: 20px" class="hint-text">
                            {{item.startDate.substr(0,10)}}至{{item.endDate.substr(0,10)}}
                        </div>
                    </div>
                    <div style="">
                        <div @click="viewDetail(item)" class="button" style="margin-right: 6px">
                            {{tabIndex==11?'使用':'详情'}}
                        </div>
                        <div v-if="tabIndex==12" @click="deleteItem(item)" class="button cannot" style="margin-right: 6px;margin-top: 6px">
                            删除
                        </div>
                    </div>

                    <!--<div v-if="tabIndex==11" @click="cancel(item)" class="button" style="margin-right: 14px">核销</div>-->
                    <!--<div v-if="tabIndex==11" @click="cancel(item)" class="button" style="margin-right: 14px">核销</div>-->
                </div>
            </div>
            <div class="no-data" v-else-if="!options.loading" style="margin-top: 30px">暂无优惠券</div>
        </mt-loadmore>
        <mt-popup
                popup-transition="popup-fade"
                v-model="popupVisible"
                position="center">
            <div class="discount-code">
                <div style="font-size: 14px;color:#999">{{tabIndex==11?'请出示下面的优惠码：':'优惠码：'}}</div>
                <div style="text-align: center;font-size: 20px;margin-top: 4px;font-family: 'Bold';color:#c3a567;font-weight: bold;position: relative;z-index: 1;margin-top: 10px">
                    {{form.discountCode}}
                </div>
                <div style="overflow-y: hidden;height: 80px;margin-top: -12px">
                    <canvas id="barcode" class="barcode" ref="barcode" style="margin:0 auto;text-align: center"></canvas>
                </div>
                <div id="canvas" class="canvas" ref="canvas"
                     style="margin:5px auto;text-align: center;padding-bottom: 15px"></div>
                <!--<div style="font-size: 40px;margin-top: 4px;font-family: 'Bold';color:#c3a567;font-weight: bold">-->
                <!--{{form.discountCode}}-->
                <!--</div>-->
            </div>
        </mt-popup>
    </div>
</template>

<script>
    import Vue from "vue";
    import api from "../api";
    import utils from "../common/utils";
    import QRCode from "qrcodejs2";
    import BarCode from "jsbarcode";
    import {Indicator, MessageBox, Toast, Popup} from 'mint-ui';

    Vue.component(Popup.name, Popup);
    export default {
        name: "MyTicket",
        data() {
            return {
                tabIndex: 11,
                utils: utils,
                list: [],
                hasBind: false,
                bindNo: "",
                popupVisible: false,
                form: {},
                options: {
                    loading: true,
                    currentPage: 1,
                    pageSize: 10,
                    hasMore: false,
                    bottomDropText: "释放加载",
                    bottomPullText: "",
                },
            }
        },
        watch: {
            tabIndex: function (value) {
                var _this = this;
                this.isRegist(() => {
                    _this.loadList(1)
                })
            }
        },
        methods: {
            loadTop: function () {
                this.options.currentPage = 1;
                this.loadList((res) => {
                    this.$refs.loadmore.onTopLoaded();
                });
            },
            loadBottom: function () {
                this.options.loading = true;
                this.options.currentPage++;
                this.loadList((res) => {
                    this.$refs.loadmore.onBottomLoaded();
                });
            },
            loadList: function (onload) {
                Indicator.open('加载中...');
                window.Indicator = Indicator;
                api.getFormUrl(this, "yy/front/discount/getGainedDiscountProduct", {
                    pageNo: this.options.currentPage,
                    pageSize: 15,
                    gainPerson: this.bindNo,
                    status: this.tabIndex
                }, (res) => {
                    if (this.options.currentPage == 1) {
                        this.list = [];
                    }
                    this.list = this.list.concat(res.data)
                    if (res.total <= res.pageNo * res.pageSize) {
                        this.options.hasMore = false;
                        this.options.bottomPullText = "没有更多了";
                    } else {
                        this.options.hasMore = true;
                        this.options.bottomPullText = "加载更多";
                    }
                    this.options.loading = false;
                    onload(res);
                    Indicator.close();
                }, () => {
                    Indicator.close();
                })
            },
            isRegist: function (callback) {
                if (this.hasBind) {
                    callback();
                } else {
                    MessageBox({
                        title: '提示',
                        closeOnClickModal:false,
                        message: '尚未绑定患者，请前往绑定?',
                        confirmButtonText: "前往绑定"
                    }).then(() => {
                        this.$router.push({
                            path: "/bindPatient",
                            query: {
                                YY_USER_ID: this.$route.query.YY_USER_ID,
                                openId: this.$route.query.openId
                            }
                        })
                    }).catch(() => {
                        // this.chargeInfo = "请先绑定患者用户"
                    });
                }
            },
            loadBindInfo: function (callback) {
                var _this = this;
                var url = "http://wx.kq123.com:10123/QSYYAjaxServer/PBClientTest?guid=" + this.$store.state.baseInfo.clientID + "&sql=is>" + this.$route.query.openId;
                Indicator.open('加载中...');

                api.corsGet(url, (res) => {
                    Indicator.close();
                    console.log(res);
                    if (res != "not find client") {
                        if (res == "") {
                            _this.hasBind = false;
                            _this.bindNo = "";
                            MessageBox({
                                title: '提示',
                                message: '尚未绑定患者，请前往绑定?',
                                confirmButtonText: "前往绑定"
                            }).then(() => {
                                _this.$router.push({
                                    path: "/bindPatient",
                                    query: {
                                        YY_USER_ID: _this.$route.query.YY_USER_ID,
                                        openId: _this.$route.query.openId
                                    }
                                })
                            }).catch(() => {
                                history.back()
                                // this.chargeInfo = "请先绑定患者用户"
                            });
                        } else {
                            _this.hasBind = true;
                            _this.bindNo = res;
                            callback && callback();
                        }
                    }
                }, (err) => {
                    Toast("网络出错，请稍后再试");
                    Indicator.close();
                    console.log(err);
                })
            },
            viewDetail: function (item) {
                var _this = this;
                Object.assign(this.form, item)
                this.popupVisible = true;
                _this.initQrcode(item.discountCode);
                _this.initBarCode(item.discountCode);
            },
            deleteItem:function (item){
                var _this =this;
                MessageBox({
                    title: '提示',
//                    closeOnClickModal:false,
                    message: '确认删除?',
                    confirmButtonText: "确认",
                    showCancelButton:true,
                    cancelButtonText: '取消'
                }).then((res) => {
                    if (res == "confirm"){
                        console.log();
                        api.postFormUrl(_this, "yy/front/discount/delNotValidDiscount", {
                            discountCode: item.discountCode,
                        }, (res) => {
                            Toast({
                                message: "删除成功",
                                position: 'bottom',
                                duration: 5000
                            });
                            Indicator.close();
                            this.loadList(1)

                        }, (msg) => {
                            Toast({
                                message: msg.rspDesc,
                                position: 'bottom',
                                duration: 5000
                            });
                            Indicator.close();
                        })
                    }else if(res == "cancel"){

                    }

                }).catch(() => {
                    // this.chargeInfo = "请先绑定患者用户"
                });

            },
            initQrcode: function (code) {
                this.$refs.canvas.innerHTML = "";
                new QRCode("canvas", {
                    width: 128,
                    height: 128,
                    text: code, // 二维码地址
                    colorDark: "#000",
                    colorLight: "#fff",
                    correctLevel : QRCode.CorrectLevel.H
                });
            },
            initBarCode: function (code) {
                console.log(code);
                BarCode("#barcode", code, {
                    // format: "CODE39",//选择要使用的条形码类型
                    width: 2.0,//设置条之间的宽度
                    height: 50,//高度
                    displayValue: true,//是否在条形码下方显示文字
                    text: "",//覆盖显示的文本
                    // fontOptions:"bold italic",//使文字加粗体或变斜体
                    font: "0",//设置文本的字体
                    color:"#c3a567",
                    textAlign: "center",//设置文本的水平对齐方式
                    textPosition: "bottom",//设置文本的垂直位置
                    background: "#fff",//设置条形码的背景
                    lineColor: "#111",//设置条和文本的颜色。
                    textMargin: 5,//设置条形码和文本之间的间距
                    fontSize: 20,//设置文本的大小
                    margin: 15//设置条形码周围的空白边距
                });
            },
            cancel: function (item) {
                api.postFormUrl(_this, "yy/front/discount/charge", {
                    discountCode: item.discountCode,
                    gainPerson: this.bindNo,
                }, (res) => {
                    Toast({
                        message: "核销成功",
                        position: 'bottom',
                        duration: 5000
                    });
                    Indicator.close();
                    this.loadList(1)
                }, (msg) => {
                    Toast({
                        message: msg.rspDesc,
                        position: 'bottom',
                        duration: 5000
                    });
                    Indicator.close();
                })
            }
        },
        mounted() {
            var _this = this;
            utils.doIF(() => {
                _this.loadBindInfo(() => {
                    _this.loadList(1)
                })
            }, () => {
                return this.$store.state.baseInfo;
            })

        }
    }
</script>

<style scoped>
    .tab-item {

    }

    .mint-loadmore-text {
        font-size: 14px;
        color: #999;
    }

    .ticket-card {
        border-radius: 2px;
        box-shadow: 0 0 4px rgba(0, 0, 0, .1);
        margin: 14px 14px 0 14px;
        background: white;
    }

    .ticket-bg {
        width: 100px;
        height: 102px;
        background: url("../assets/img/card_pre.gif") 0 0;
        background-size: cover;
    }

    .hint-text {
        color: #999;
    }

    .button {
        padding: 6px 0px;
        width: 60px;
        white-space: nowrap;
        box-sizing: border-box;
        text-align: center;
        color: white;
        background: linear-gradient(45deg, #3764f6, #7798fd);
        border-radius: 100px;
    }

    .button.cannot {
        background: #bbb;
    }

    .list-view {
        padding-bottom: 20px;
    }

    .no-data {
        letter-spacing: 2px;
        margin-top: 30px;
    }

    .discount-code {
        left: 5rem;
        right: 5rem;
        padding: 8px 15px;
        min-width: 20rem;
    }

    .canvas > * {
        margin: auto;
        display: block;
    }
</style>
<style>
    .canvas > img {
        margin: auto;
    }

    .barcode {
        display: block;
        margin: auto;
    }
</style>